import { useMemo } from "react";
import { AutocompleteInput, ChoicesContext, ReferenceInput, required, useChoicesContext } from "react-admin";
import { administrationRequests } from "api/administrationApi";
import GridItem from "./GridItem";

// Filter the context, not a `choices` prop — that would replace the ReferenceInput's server search.
const ExcludedChoices = ({ excludeIds, children }) => {
  const context = useChoicesContext();

  const filteredContext = useMemo(() => {
    const isAllowed = choice => !excludeIds.includes(choice?.id);
    return {
      ...context,
      allChoices: (context.allChoices ?? []).filter(isAllowed),
      availableChoices: (context.availableChoices ?? []).filter(isAllowed),
    };
  }, [context, excludeIds]);

  return <ChoicesContext.Provider value={filteredContext}>{children}</ChoicesContext.Provider>;
};

const DisciplineInput = ({ source = "disciplineId", label = "Дисциплина", md = 12, filter, excludeIds = [] }) => (
  <GridItem md={md}>
    <ReferenceInput
      source={source}
      reference={administrationRequests.getDisciplinesSelect()}
      filter={filter}
    >
      <ExcludedChoices excludeIds={excludeIds}>
        <AutocompleteInput
          optionText="name"
          label={label}
          fullWidth
          validate={required("Полето е задължително.")}
          filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
        />
      </ExcludedChoices>
    </ReferenceInput>
  </GridItem>
);

export default DisciplineInput;
